/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class JobadPinIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      fill="currentcolor"
      width="24px"
      height="24px"
      viewBox="0 0 24 24" {...this.props}>
      <g id="pin1">
        <g
          id="pin"
          transform="translate(7.000000, 4.000000)"
        >
          <path
            d="M0.933459945,7.84348744 C0.445084878,7.15535604 0.129087229,6.33800861 0.0477988557,5.45331855 C-0.077784446,4.56610265 0.044093693,3.76036968 0.413433267,3.03611963 C0.474159464,2.91703964 0.536499077,2.80270963 0.600258804,2.69294022 C0.93418537,2.06494552 1.40028446,1.51692488 1.96180386,1.0853603 C3.30976111,0.0159112922 4.71445186,0.0525246838 5.00944014,0.0525246838 C5.07277148,0.0525246838 5.21640566,0.0522687735 5.41749794,0.068873189 C5.60025807,0.0835786114 5.78023051,0.10807437 5.95688235,0.141831445 C7.00370381,0.338285833 8.63760362,0.966862143 9.59006869,2.97798701 C9.90429282,3.64146961 10.0378706,4.34961136 9.99080198,5.10241227 C9.96917911,6.14211922 9.62434048,7.10298989 9.05197934,7.89003454 L5.00944014,14.8899473 L0.933459945,7.84348744 Z M5.00944014,6.85301004 C6.04133794,6.85301004 6.87785633,6.0226425 6.87785633,4.99833222 C6.87785633,3.97402194 6.04133794,3.14365439 5.00944014,3.14365439 C3.97754241,3.14365439 3.14102399,3.97402194 3.14102399,4.99833222 C3.14102399,6.0226425 3.97754241,6.85301004 5.00944014,6.85301004 Z"
            id="Oval-5"
          />
        </g>
      </g>
    </svg>;
  }
}

const Icon = pure(JobadPinIcon);
Icon.displayName = 'JobadPinIcon';
export default Icon;
